import type { UpsellingModalScenarioContent } from '@front-platform/content-builder';
import { UPSELLING_MODAL_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import type { Cb2PreviewScenarioPayload } from '@core/services/cb2-preview/cb2-preview-protocol';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { resolvePreviewScenarioForBloc } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';

/** Studio preview supplies the upselling rule. Outside preview, the store does. */
export function resolveUpsellingModalPreviewContent(input: {
  isPreview: boolean;
  scenarios: Readonly<Record<string, Cb2PreviewScenarioPayload>>;
  blocKey: string | null | undefined;
}): UpsellingModalScenarioContent | null {
  if (!input.isPreview) {
    return null;
  }

  return previewScenarioData<UpsellingModalScenarioContent>(
    resolvePreviewScenarioForBloc(input.scenarios, input.blocKey, UPSELLING_MODAL_COMPONENT),
    UPSELLING_MODAL_COMPONENT,
  );
}
